export default __webpack_public_path__ + "e066977677a3bda5a110d5a5c128f873.png";